import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../../store'

// Define a type for the slice state
interface NavigatorState {
  value: string
}

// Define the initial state using that type
const initialState: NavigatorState = {
  value: 'Métricas Generales'
}

export const navigatorSlice = createSlice({
  name: 'navigator',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  // Reducers son las "funciones" que voy a tener
  reducers: {
    menuSelected: (state, action: PayloadAction<string>) => {
        state.value = action.payload
      },
  },
})

export const { menuSelected} = navigatorSlice.actions

export const selectNavigator = (state: RootState) => state.navigator.value

export default navigatorSlice.reducer

